<template>
  <div v-if="isShow" class="pt-2 pl-1">
    <base-svg-icon @click="router.back()" class="w-7 cursor-pointer" :path="mdiChevronLeft" />
  </div>
</template>

<script lang="ts">
import { defineComponent, onBeforeUpdate, onMounted, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from '@/store/index'

import { mdiChevronLeft } from '@mdi/js'
import BaseSvgIcon from '@/components/BaseSvgIcon.vue'
import { RoleAttributes } from '@/types/models/role'

export default defineComponent({
  components: { BaseSvgIcon },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const store = useStore()

    const isShow = ref(false)
    const setShow = () => {
      let onlyWellLabo = false
      if (store.state.user.user) {
        // ウェルラボのみユーザーは戻るボタン非表示
        const isWellLabo = !!store.state.user.user.roles.find((element:RoleAttributes) => element.slug === 'well_labo')
        onlyWellLabo = isWellLabo && store.state.user.user.roles.length === 1
      }

      isShow.value = !!(
        route.name !== 'Home'
        && route.name !== 'VideoDetails'
        && !onlyWellLabo
      )
    }

    onBeforeUpdate(() => {
      setShow()
    })

    onMounted(() => {
      setShow()
    })

    return {
      mdiChevronLeft,
      router,
      isShow
    }
  },
})
</script>
